export class ProfileRead {
  public ProfileId: number;
  public OrgInd: boolean;
  public OrgName: string;
  public FirstName: string;
  public LastName: string;
  public Mi: string;
  public Prefix: string;
  public Suffix: string;
  public Pronouns: string;
  public Title: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public ZipExt: string;
  public County: string;
  public Country: string;
  public WorkPhone: string;
  public PhoneDefault: string;
  public HomePhone: string;
  public CellPhone: string;
  public Ext: string;
  public Fax: string;
  public Email: string;
  public Website: string;
  public Member: boolean;
  public Prospect: boolean;
  public Employee: boolean;
  public Vendor: boolean;
  public ReportName: string;
  public ASF: string;
  public EmployeesFT: number;
  public EmployeesPT: number;
  public NAICSCode: string;
  public SicCode: string;
  public Referredby: string;
  public SalFormal: string;
  public SalInformal: string;
  public SalMailLabel: string;
  public Sal4: string;
  public Sal5: string;
  public Sal6: string;
  public Gender: string;
  public BirthDate: string;
  public TaxID: string;
  public UserName: string;
  public Password: string;
  public PreferedContact: string;
  public Inactive: boolean;
  public CustStatus: string;
  public SoldBy: number;
  public AssignedTo: number;
  public BillManually: boolean;
  public PreferredPaymentMethod: string;
  public CreditRating: string;
  public DBA: string;
  public NoEmail: boolean;
  public ImageURL: string;
  public NoFax: boolean;
  public InheritAddressFrom: number;
  public PreferredEmailType: string;
  public InheritPhoneFrom: number;
  public Customers: number;
  public EncryptedProfileID: string;
  public ProfileTypeId: number;
  public PreferredBillingMethod: string;
  public MembershipLevelId: number;
  public ExternalId: string;
  public UC1: string;
  public UC2: string;
  public UC3: string;
  public UC4: string;
  public UC5: string;
  public UC6: string;
  public UC7: string;
  public UC8: string;
  public UC9: string;
  public UC10: string;
  public MemberTypeIconColor: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public DisablePortalLogin: boolean;
}
